import { legacy_createStore as createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
// import { composeWithDevTools } from 'redux-devtools-extension'

import rootReducer from '../reducers'
import rootSaga from '../sagas'

const sagaMiddleware = createSagaMiddleware()

//const enhancer = composeWithDevTools(applyMiddleware(sagaMiddleware))
const enhancer = (applyMiddleware(sagaMiddleware))
const args = [rootReducer, enhancer]

export default (() => {
  const store = createStore(...args)
  sagaMiddleware.run(rootSaga)
  return store
})()
